<!-- App.vue
  This component is the root component for our Vue application. It is rendered
  in the project root's index.html file with the <div id="app"> tag. The Firebase
  instance exists only within this component.
-->
<template>
  <v-app :class="{ hasHandwrittenFont }">
    <vue-progress-bar></vue-progress-bar>
    <router-view></router-view>
    <vue-toastr ref="toastr"></vue-toastr>
  </v-app>
</template>

<script>
// import Vuex from "vuex";
// import Config from '../config-app/config';
// import authentication from './js/auth'
// import { getAuth } from "firebase/auth";
// import mixins from './js/mixins'

// const auth = getAuth();
import FontFaceObserver from "fontfaceobserver";

export default {
  name: "app",
  data() {
    return {
      currentWidth: window.innerWidth,
      mobileBreakPoint: 1024,
      hasHemiHeadFont: false,
      hasHandwrittenFont: false,
    };
  },

  methods: {
    setCurrentWidth() {
      this.currentWidth = window.innerWidth;
    },
  },

  computed: {
    isMobile() {
      return this.currentWidth <= parseInt(this.mobileBreakPoint);
    },
  },

  watch: {
    isMobile: {
      handler(val) {
        this.$store.dispatch("setMobile", val);
      },
      immediate: true,
    },
    user_uid: {
      async handler(val) {
        // console.log("auth changed");

        if (val) {
          // console.log("logged in");

          // non mettere alcuna logica qui
          // fallo in router
        } else {
          // console.log("logged out");

          // no redirect qui per evitare loops
          // tanto può succedere solo a developer e in standalone
          this.$router.push({
            path: "/login",
          });
        }
      },
      immediate: false,
    },
  },
  mounted() {
    console.log("--> App mounted.");
    window.addEventListener("resize", this.setCurrentWidth);
    // font
    const handwrittenFont = new FontFaceObserver("Caveat");
    handwrittenFont.load().then(() => {
      this.hasHandwrittenFont = true;
    });
  },
  destroyed() {
    console.log("<-- App destroyed.");
    window.removeEventListener("resize", this.setCurrentWidth);
  },
};
</script>


